import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_LOCALE,
  getIntlLocaleTag,
  I18N_RESOURCES,
  resolveLocale,
  SUPPORTED_LOCALES,
} from "@/lib/locales";

export const I18N_NAMESPACES = Object.keys(
  I18N_RESOURCES.en,
) as (keyof typeof I18N_RESOURCES.en)[];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: I18N_RESOURCES,
    // Omit `lng` so localStorage + navigator run; setting it forced English on every reload.
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    ns: [...I18N_NAMESPACES],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = resolveLocale(lng);
});

document.documentElement.lang = resolveLocale(i18n.language);

/** BCP 47 tag for `Intl` formatters from the active i18n language. */
export function getIntlLocale(): string {
  return getIntlLocaleTag(resolveLocale(i18n.resolvedLanguage ?? i18n.language));
}

export default i18n;
